var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManabakhBrandName = function SvgManabakhBrandName(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#manabakhBrandName_svg__a)",
    d: "M36.877 27.75 43 21.637v-9.313C43 5.65 37.591.25 30.907.25H14.559L8.437 6.363h28.44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#manabakhBrandName_svg__b)",
    d: "M36.877 6.363A6.11 6.11 0 0 0 30.755.25h-9.86v6.113z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#manabakhBrandName_svg__c)",
    d: "M6.264.25.14 6.363v9.313c0 6.674 5.409 12.074 12.094 12.074h16.347l6.123-6.113H6.264z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#manabakhBrandName_svg__d)",
    d: "M6.264 21.637a6.11 6.11 0 0 0 6.123 6.113h6.456v-6.113z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.16 13.189-4.147-2.397a.951.951 0 0 0-1.428.82v4.777a.951.951 0 0 0 1.428.82l4.148-2.367a.953.953 0 0 0 0-1.653"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "manabakhBrandName_svg__a",
    x1: 22.544,
    x2: 33.763,
    y1: 19.491,
    y2: 0.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "manabakhBrandName_svg__b",
    x1: 20.893,
    x2: 36.878,
    y1: 3.306,
    y2: 3.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "maroon",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#490000",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#210000",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#090000",
    stopOpacity: 0.915
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "manabakhBrandName_svg__c",
    x1: 9.357,
    x2: 20.576,
    y1: 27.962,
    y2: 8.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#FF7E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FF9893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA29E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "manabakhBrandName_svg__d",
    x1: 6.269,
    x2: 18.853,
    y1: 24.698,
    y2: 24.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#090000",
    stopOpacity: 0.915
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#210000",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#490000",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "maroon",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red",
    stopOpacity: 0
  })))));
};
export default SvgManabakhBrandName;